import { GraduationCap } from "lucide-react";
import { paths } from "../../../routes/paths";
import { ROLE } from "../../../utils/constant";


const { trainings } = paths;

export const counsellorMenuItems = [
  {
    id: "trainings",
    title: "Training",
    // url: "/dashboard/organization",
    type: "collapse",
    role: ROLE.ALLOWED_SALES_DEPT,
    icon: <GraduationCap />,
    activeIco: <GraduationCap />,
    children: [
      {
        id: "dashboard",
        title: "Dashboard",
        parent: "trainings",
        url: trainings.root,
        type: "item",
        role: ROLE.ALLOWED_SALES_DEPT,
      },
      {
        id: "program",
        parent: "Program",
        title: "Program",
        url: trainings.program,
        type: "item",
        role: ["Teacher", "Admin", "HR"],
      },
      {
        id: "class-session",
        title: "Class/Session",
        url: trainings.classes,
        parent: "organization",
        type: "item",
        role: ["Teacher", "Admin", "HR"],
      },
      {
        id: "traininers",
        title: "Trainers",
        url: trainings.trainers,
        parent: "organization",
        type: "item",
        role: ["Admin", "HR"],
      },
      {
        id: "counselors",
        title: "Counselors",
        url: trainings.counselors,
        parent: "organization",
        type: "item",
        role: ["Admin", "HR"],
      },
      {
        id: "students-ist",
        title: "Students List",
        url: trainings.students,
        parent: "organization",
        type: "item",
        role: ROLE.ALLOWED_SALES_DEPT,
      },
      {
        id: "payments",
        title: "Payments",
        url: trainings.payments,
        parent: "organization",
        type: "item",
        role: ["Admin", "HR"],
      },
      {
        id: "fee",
        title: "Fee Management",
        url: trainings.fee,
        parent: "organization",
        type: "item",
        role: ["Admin", "HR"],
      },
    ],
  },
];
